import { Link, useLocation } from "wouter";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Menu, X, Phone } from "lucide-react";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "@/assets/select_cleaning_logo.png";

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const [location] = useLocation();

    const links = [
        { href: "/", label: "Home" },
        { href: "/residential", label: "Residential" },
        { href: "/commercial", label: "Commercial" },
        { href: "/franchise", label: "Franchise" },
    ];

    return (
        <nav className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-sm shadow-sm border-b border-gray-100">
            <div className="container mx-auto px-4 h-20 flex items-center justify-between">
                <Link href="/">
                    <a className="flex items-center gap-2">
                        <img src={logo} alt="Select Cleaning — Professional home and commercial cleaning Auckland" className="h-10 w-auto" width="319" height="40" />
                    </a>
                </Link>

                {/* Desktop Menu */}
                <div className="hidden md:flex items-center gap-8">
                    {links.map((link) => (
                        <Link key={link.href} href={link.href}>
                            <a
                                className={cn(
                                    "text-sm font-medium transition-colors hover:text-primary",
                                    location === link.href ? "text-primary font-bold" : "text-gray-600"
                                )}
                            >
                                {link.label}
                            </a>
                        </Link>
                    ))}
                    <Button asChild className="bg-primary text-white hover:bg-primary/90">
                        <a href="tel:0800223315">
                            <Phone className="mr-2 h-4 w-4" />
                            0800 22 33 15
                        </a>
                    </Button>
                </div>

                {/* Mobile Toggle */}
                <button
                    className="md:hidden p-2 text-gray-600 hover:text-primary"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {isOpen ? <X /> : <Menu />}
                </button>
            </div>

            {/* Mobile Menu */}
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        className="md:hidden border-t border-gray-100 bg-white shadow-lg"
                    >
                        <div className="container mx-auto px-4 py-4 flex flex-col gap-4">
                            {links.map((link) => (
                                <Link key={link.href} href={link.href}>
                                    <a
                                        className={cn(
                                            "text-sm font-medium transition-colors hover:bg-gray-50 p-2 rounded-md block",
                                            location === link.href ? "text-primary font-bold bg-gray-50" : "text-gray-600"
                                        )}
                                        onClick={() => setIsOpen(false)}
                                    >
                                        {link.label}
                                    </a>
                                </Link>
                            ))}
                            <Button asChild className="w-full bg-primary text-white hover:bg-primary/90">
                                <a href="tel:0800223315">
                                    <Phone className="mr-2 h-4 w-4" />
                                    0800 22 33 15
                                </a>
                            </Button>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </nav>
    );
}
